import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMobileAdd = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1818 30H14.8182C14.336 30 13.8735 29.8084 13.5325 29.4675C13.1916 29.1265 13 28.664 13 28.1818V11.8182C13 11.336 13.1916 10.8735 13.5325 10.5325C13.8735 10.1916 14.336 10 14.8182 10H25.7273C26.2095 10 26.6719 10.1916 27.0129 10.5325C27.3539 10.8735 27.5455 11.336 27.5455 11.8182V20",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.5455 24.5454V30",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.8182 27.2727H30.2727",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgMobileAdd);
export default ForwardRef;
